
import { Button } from "@mui/material";
import FormPreview from "../../../Masters/TemplateMaster/formMaster/components/formView";

import { ReactSketchCanvas } from "react-sketch-canvas";
import { renderPdfWithFields } from "./renderPdfWithFields";
type Props = {
    formData: any;
    setFormData: any;
    patientData: any; 
    signatureFields: any[];
    activeSignatureField: any;
    setSelectedSignatureField: any;
    canvasRef: any;
};

const CustomFormWithPatient = ({
    formData,
    setFormData,
    patientData,
    signatureFields,
    activeSignatureField,
    canvasRef,
}: Props) => {
    const handleSetValue = (key: string, updatedFields: any) => {
  if (key === "fields") {
    setFormData({
      ...formData,
      templateMetadata: {
        ...formData.templateMetadata,
        fields: updatedFields,
      },
    });
  }
};
    const mergedFields =
        formData?.templateMetadata?.fields?.map((field: any) => {
            if (!field.keyName) return field;

            const map: Record<string, any> = {
                patientName: patientData?.pmaster?.patientName,
                firstName: patientData?.pmaster?.firstName,
                lastName: patientData?.pmaster?.lastName,
                dob: patientData?.pmaster?.dob,
                gender: patientData?.pmaster?.gender,
                emrNo: patientData?.pmaster?.patientId,
                doctorName: patientData?.encounter?.doctorName,
                clinicName: patientData?.encounter?.clinicName,
                emiratesId: patientData?.amaster?.emiratesId,
                mobileNo: patientData?.amaster?.mobileNo,
                clinicCountryName: patientData?.amaster?.clinicCountryName,
                departmentName: patientData?.encounter?.departmentName,
                purposeName: patientData?.encounter?.purposeName,
            };

            return {
                ...field,
               value:
  field.value !== undefined && field.value !== null && field.value !== ""
    ? field.value
    : map[field.keyName] ?? "",
            };
        }) || [];

    return (
        <div className="w-[90vw] h-[90dvh] flex gap-6 p-6 bg-gray-50">

            {/* LEFT */}
            <div className="flex-1 flex flex-col bg-white shadow-md rounded-lg border overflow-hidden h-full">
                <div className="p-4 border-b flex justify-between shrink-0 bg-white z-10">
                    <h2>Document Content</h2>
                   <Button
  onClick={async () => {
    const updatedFormData = {
  ...formData,
  templateMetadata: {
    ...formData.templateMetadata,
    fields: mergedFields, 
  },
};

const blob = await renderPdfWithFields(updatedFormData, patientData);

    const url = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
console.log("PRINT FIELDS:", mergedFields);
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow?.print();
    };
  }}
>
  Print
</Button>
                </div>

                <div className="p-6 overflow-y-auto flex-1 bg-gray-50/20">
                    <div className="w-[211mm] mx-auto bg-white shadow border">
                        {formData && (
                            <FormPreview
                                watchData={{
                                    templateImage: formData.templateMetadata.templateImage.startsWith("data:")
                                        ? formData.templateMetadata.templateImage
                                        : `data:application/pdf;base64,${formData.templateMetadata.templateImage}`,
                                    fields: mergedFields, 
                                }}
                                 setValue={handleSetValue}
                                mode="emr"
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* RIGHT: ACTION PANEL */}
            <div className="w-full md:w-[360px] shrink-0 h-full overflow-y-auto bg-white shadow-md rounded-lg p-6 border border-gray-200 flex flex-col gap-8">
                <div className="flex flex-col gap-4">
                    <h2 className="text-lg font-semibold text-gray-800 border-b pb-3 m-0">Authorization</h2>

                    {signatureFields.length > 0 ? (
                        <>
                            <div className="flex flex-col gap-2">
                                <span className="text-sm font-medium text-gray-700">Select Signature to Fill:</span>
                             
                            </div>

                            {activeSignatureField && (
                                <div className="flex flex-col gap-2 mt-2">
                                 
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg overflow-hidden bg-white hover:border-blue-400 transition-colors relative">
                                        {activeSignatureField.src && (
                                            <div className="absolute inset-0 bg-white/90 z-10 flex flex-col items-center justify-center">
                                                <span className="text-sm font-bold text-green-600 mb-2">Signature Captured</span>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={() => {
                                                        const updatedFields = formData.templateMetadata.fields.map((f: any) =>
                                                            f.id === activeSignatureField.id ? { ...f, src: null, type: "signature", originalType: "signature" } : f
                                                        );
                                                        setFormData({
                                                            ...formData,
                                                            templateMetadata: { ...formData.templateMetadata, fields: updatedFields }
                                                        });
                                                        setTimeout(() => canvasRef.current?.clearCanvas(), 50);
                                                    }}
                                                >
                                                    Retake Signature
                                                </Button>
                                            </div>
                                        )}
                                        <ReactSketchCanvas
                                            ref={canvasRef}
                                            width="100%"
                                            height="200px"
                                            strokeWidth={3}
                                            strokeColor="black"
                                            canvasColor="transparent"
                                            style={{
                                                border: "none",
                                                background: "transparent"
                                            }}
                                        />
                                    </div>
                                    <div className="flex justify-between items-center mt-2">
                                        <Button
                                            size="small"
                                            color="error"
                                            onClick={() => canvasRef.current?.clearCanvas()}
                                            className="!text-xs"
                                            disabled={!!activeSignatureField.src}
                                        >
                                            Clear Canvas
                                        </Button>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            className="!text-xs"
                                            disabled={!!activeSignatureField.src}
                                            onClick={async () => {
                                                const base64 = await canvasRef.current?.exportImage("png");
                                                const updatedFields = formData.templateMetadata.fields.map((f: any) =>
                                                    f.id === activeSignatureField.id ? { ...f, src: base64, type: "image", originalType: "signature" } : f
                                                );
                                                setFormData({
                                                    ...formData,
                                                    templateMetadata: { ...formData.templateMetadata, fields: updatedFields }
                                                });
                                            }}
                                        >
                                            Apply to Document
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="text-sm text-gray-500 italic p-4 bg-gray-100 rounded-md border border-gray-200">
                            No doctors signature fields detected on this form template.
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
};

export default CustomFormWithPatient;